import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Issues from "./Issue/Issues";
import MaterialIssueHistory from "./Issue/MaterialIssueHistory";
import MaterialList from "./MaterialList/MaterialList";
import PurchaseHistory from "./Purchase/PurchaseHistory";
import Purchases from "./Purchase/Purchases";
import AllTransactions from "./AllTransactions/AllTransactions";
import PurchaseOrder2 from "./PurchaseOrder/PurchaseOrder2";

export default function MaterialStockLayout() {
  /*   All States
   ********************************************* */
  const [searchParams, setSearchParams] = useSearchParams();
  const [active, setActive] = useState("materials");

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    // Set active tab based on search params
    const tab = searchParams.get("tab") || "materials";
    setActive(tab);
  }, [searchParams]);
  return (
    <div
      className="px-3 py-2"
      style={{
        marginLeft: 260,
        height: "100vh",
      }}
    >
      <h2 className="mb-2">Materials Stock List</h2>
      {/* Nav Tabs */}
      <ul className="nav nav-tabs nav-bordered border-0 d-flex flex-grow-1 mb-3">
        <li
          onClick={() => {
            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              delete prev["materialId"];
              return {
                ...prev,
                tab: "materials",
                "material-page": searchParams.get("material-page") || 1,
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "materials"
                ? `btn btn-primary active bg-primary text-white`
                : "bg-white btn"
            }
          >
            <span className="d-none d-md-block">Materials List</span>
          </button>
        </li>
        <li
          onClick={() => {
            let materialId = searchParams.get("materialId");
            if (!materialId) {
              return;
            }
            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }

              return {
                ...prev,
                tab: "material-purchase",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          disabled={
            searchParams.get("materialId") === null ||
            searchParams.get("materialId") === undefined
          }
          className="nav-item"
        >
          <button
            disabled={
              searchParams.get("materialId") === null ||
              searchParams.get("materialId") === undefined
            }
            className={
              active === "material-purchase"
                ? `btn btn-primary active bg-primary text-white`
                : `${
                    searchParams.get("materialId")
                      ? "bg-white btn"
                      : "bg-white bg-opacity-75  btn"
                  }`
            }
          >
            <span className="d-none d-md-block">Material Purchase</span>
          </button>
        </li>
        <li
          onClick={() => {
            let materialId = searchParams.get("materialId");
            if (!materialId) {
              return;
            }

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "material-issue",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          disabled={
            searchParams.get("materialId") === null ||
            searchParams.get("materialId") === undefined
          }
          className="nav-item"
        >
          <button
            disabled={
              searchParams.get("materialId") === null ||
              searchParams.get("materialId") === undefined
            }
            className={
              active === "material-issue"
                ? `btn btn-primary active bg-primary text-white`
                : `bg-white btn`
            }
          >
            <span className="d-none d-md-block">Material Issue</span>
          </button>
        </li>
        {/* <li
          onClick={() => {
            let materialId = searchParams.get("materialId");

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "purchase-order",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "purchase-order"
                ? `btn btn-primary active bg-primary text-white`
                : `${
                    searchParams.get("materialId")
                      ? "bg-white btn"
                      : "bg-white bg-opacity-75 btn"
                  }`
            }
          >
            <span className="d-none d-md-block">Purchase Order</span>
          </button>
        </li> */}
        {/* <li
          onClick={() => {
            let materialId = searchParams.get("materialId");

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "purchase-order",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "purchase-order"
                ? `btn btn-primary active bg-primary text-white`
                : `${
                    searchParams.get("materialId")
                      ? "bg-white btn"
                      : "bg-white bg-opacity-75 btn"
                  }`
            }
          >
            <span className="d-none d-md-block">Purchase Order</span>
          </button>
        </li> */}
        <li
          onClick={() => {
            let materialId = searchParams.get("materialId");

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "purchase-history",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "purchase-history"
                ? `btn btn-primary active bg-primary text-white`
                : `${
                    searchParams.get("materialId")
                      ? "bg-white btn"
                      : "bg-white bg-opacity-75 btn"
                  }`
            }
          >
            <span className="d-none d-md-block">Purchase History</span>
          </button>
        </li>
        <li
          onClick={() => {
            let materialId = searchParams.get("materialId");

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "issue-history",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "issue-history"
                ? `btn btn-primary active bg-primary text-white`
                : `bg-white btn`
            }
          >
            <span className="d-none d-md-block">Issue History</span>
          </button>
        </li>
        <li
          onClick={() => {
            let materialId = searchParams.get("materialId");

            setSearchParams((prev) => {
              delete prev["sort"];
              delete prev["order"];
              delete prev["query"];
              delete prev["page"];
              if (materialId) {
                prev["materialId"] = materialId;
              }
              return {
                ...prev,
                tab: "all-transactions",
                page: 1,
                filterBy: "all",
                limit: "10",
              };
            });
          }}
          className="nav-item"
        >
          <button
            className={
              active === "all-transactions"
                ? `btn btn-primary active bg-primary text-white`
                : `bg-white btn`
            }
          >
            <span className="d-none d-md-block">All Transactions</span>
          </button>
        </li>
      </ul>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div
              className="card-body"
              style={{
                height: "85vh",
                overflowY: "auto",
              }}
            >
              {/* Tab Content */}
              <div className="tab-content ">
                {active === "materials" && (
                  <div className="tab-pane show active ">
                    <MaterialList />
                  </div>
                )}
                {active === "material-purchase" && (
                  <div className="tab-pane show active ">
                    <Purchases />
                  </div>
                )}
                {active === "material-issue" && (
                  <div className="tab-pane show active">
                    <Issues />
                  </div>
                )}
                {active === "purchase-history" && (
                  <div className="tab-pane show active">
                    <PurchaseHistory />
                  </div>
                )}
                {/* {active === "purchase-order" && (
                  <div className="tab-pane show active">
                    <PurchaseOrder2 />
                  </div>
                )} */}
                {/* {active === "purchase-order" && (
                  <div className="tab-pane show active">
                    <PurchaseOrder />
                  </div>
                )} */}
                {active === "issue-history" && (
                  <div className="tab-pane show active">
                    <MaterialIssueHistory />
                  </div>
                )}
                {active === "all-transactions" && (
                  <div className="tab-pane show active">
                    <AllTransactions />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
